import { Routes } from '@angular/router';
import { HomeComponent } from './pages/home/home.component';
import { AboutComponent } from './pages/about/about.component';
import { ServicesComponent } from './pages/services/services.component';
import { ProjectsComponent } from './pages/projects/projects.component';
import { DivisionsComponent } from './pages/divisions/divisions.component';
import { ContactComponent } from './pages/contact/contact.component';
import { ExpertiseComponent } from './pages/expertise/expertise.component';
import { ExpertiseDetailComponent } from './pages/expertise/expertise-detail.component';
import { DynamicPageComponent } from './pages/dynamic-page/dynamic-page.component';
import { ProjectDetailComponent } from './pages/projects/project-detail.component';
import { ServiceDetailComponent } from './pages/services/service-detail.component';
import { BlogListComponent } from './pages/blog/blog-list.component';
import { BlogPostComponent } from './pages/blog/blog-post.component';
import { SitemapComponent } from './pages/sitemap/sitemap.component';
import { SITE_CONFIGS } from './core/config/sites';
import { environment } from '../environments/environment';

const siteConfig = SITE_CONFIGS[environment.siteId];
const seo = siteConfig?.routeSeo || {};

export const routes: Routes = [
  {
    path: '',
    component: HomeComponent,
    data: { seo: seo[''] },
  },
  {
    path: 'about',
    component: AboutComponent,
    data: { seo: seo['about'] },
  },
  {
    path: 'services',
    component: ServicesComponent,
    data: { seo: seo['services'] },
  },
  {
    path: 'projects',
    component: ProjectsComponent,
    data: { seo: seo['projects'] },
  },
  // Corporate-only: divisions page
  ...(siteConfig?.siteType === 'corporate' ? [{
    path: 'divisions',
    component: DivisionsComponent,
    data: { seo: seo['divisions'] },
  }] : []),
  {
    path: 'contact',
    component: ContactComponent,
    data: { seo: seo['contact'] },
  },
  // Division-only: expertise page
  ...(siteConfig?.siteType === 'division' ? [
    {
      path: 'expertise',
      component: ExpertiseComponent,
      data: { seo: seo['expertise'] },
    },
    {
      path: 'expertise/:slug',
      component: ExpertiseDetailComponent,
    },
  ] : []),
  {
    path: 'blog',
    component: BlogListComponent,
    data: { seo: seo['blog'] },
  },
  {
    path: 'sitemap',
    component: SitemapComponent,
  },
  { path: 'services/:slug', component: ServiceDetailComponent },
  { path: 'projects/:slug', component: ProjectDetailComponent },
  { path: 'blog/:slug', component: BlogPostComponent },
  { path: ':slug', component: DynamicPageComponent },
];
